import React from "react";
import { requireAuth } from "../util/auth";
import { Container } from "@material-ui/core";
import CreateVariableForm from "../components/CreateVariableForm";
import ListVariables from "../components/ListVariables";

function VariablesPage() {
  return (
    <Container maxWidth="md">
      <h1>My Variables</h1>
      <CreateVariableForm />
      <ListVariables />
    </Container>
  );
}

export default requireAuth(VariablesPage);
